module.exports = __webpack_public_path__ + "media/img/specialize/item10-9d0ed6b7f77056dbd54695f41015cfd9.svg";